import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import { collection, doc, getDoc, getDocs, limit, query, where } from 'firebase/firestore';
import Dashboard from './Dashboard';
import ParentDashboard from './ParentDashboard';

const DashboardEntry = () => {
  const [loading, setLoading] = useState(true);
  const [role, setRole] = useState(null);

  useEffect(() => {
    const loadRole = async () => {
      try {
        const user = auth.currentUser;
        if (!user) {
          setRole(null);
          return;
        }

        let userDoc = await getDoc(doc(db, 'users', user.uid));
        if (!userDoc.exists()) {
          const uidQuery = query(collection(db, 'users'), where('uid', '==', user.uid), limit(1));
          const snapshot = await getDocs(uidQuery);
          if (!snapshot.empty) {
            userDoc = snapshot.docs[0];
          }
        }

        setRole(userDoc.exists() ? userDoc.data().role : null);
      } finally {
        setLoading(false);
      }
    };

    loadRole();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-gray-600">Loading dashboard...</div>
      </div>
    );
  }

  if (role === 'parent') {
    return <ParentDashboard />;
  }

  return <Dashboard />;
};

export default DashboardEntry;
